module.exports = __webpack_public_path__ + "static/coliving-bath-3b692b32c65ca8b6c113c85fabed9683.jpg";